import dayjs, { Dayjs } from "dayjs";
import { EMPTY_STR } from "@/constants/string";

export const formatLearningProgressDateValue = (value: Dayjs | string | null): string => {
  if (!value) return EMPTY_STR.DATE;
  const day = dayjs(value);
  return day.isValid() ? day.format("YYYY/MM/DD") : EMPTY_STR.DATE;
};
